import http from '../http-common'
class DataService {
    log (data) {
        return http.post('/log', data);
    }

    submitRegistration(formData) {
        const response = http.post(`/registrations`, {
        Name: formData.name,
        Surname: formData.surname,
        Email: formData.email,
        Affiliation: formData.affiliation,
        Subscription_type: formData.subscriptionString,
        isIEEE: formData.isIEEEMember,
        IEEE_number: formData.ieeeNumber,
        Paper_ID: formData.paperId,
        Dietary: formData.dietaryString,
        Allergies: formData.allergies,
        Hotel: formData.hotelLocation,
        Arrival: formData.arrivalDate,
        Departure: formData.departureDate,
        Payment_type: formData.paymentMethod,
        USD: formData.USD,
        COP: formData.COP,
        recaptchaToken: formData.recaptchaToken,
        });
        return response;
      }
}

export default new DataService()
